import 'v-autocomplete/dist/v-autocomplete.css'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from './App.vue'
import Autocomplete from 'v-autocomplete'
import axios from 'axios';
import VueAnalytics from 'vue-analytics'
var VueCookie = require('vue-cookie');

window.axios = axios;

if (window.location.href.indexOf('localhost') > 0) {
  window.axios.defaults.baseURL = 'http://localhost:8000';
  //window.axios.defaults.baseURL = 'https://gla-your-commute-2.appspot.com';
} else {
  window.axios.defaults.baseURL = 'https://gla-your-commute-2.appspot.com';
}

window.journeyScrolling = false;

Vue.use(VueScrollTo, {
  cancelable: false,
  onStart() {
    window.journeyScrolling = true;
  },
  onDone() {
    window.journeyScrolling = false;
  }
});

Vue.use(Autocomplete)

Vue.use(VueAnalytics, {
  id: 'UA-741115-85',
  disableScriptLoader: true // load in index.html instead for tests compatibility
})

Vue.use(VueCookie)

new Vue({
  el: '#app',
  render: h => h(App),
  mounted() {
    this.$ga.page('/');
  }
})





// WEBPACK FOOTER //
// ./src/main.js